// Bootstrap first, so every rule in style.css below still wins where the old
// site's <link> order made it win. Both come from npm now rather than from a
// CDN: the exact version is in the lockfile, the build fails if it is missing
// instead of the browser silently rendering an unstyled page, and a visitor's
// address no longer goes to jsdelivr on every page view.
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/style.css";

// The two Bootstrap components this site uses, imported for their side effect:
// each registers the document-level click handler behind its data-bs-*
// attributes. The full bundle would also carry the dropdown, modal, tooltip
// and popover, and Popper with them.
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";

import { createApp } from "vue";

import App from "./App.vue";
import { createAppRouter } from "./router";

const app = createApp(App);
const router = createAppRouter();

// use() before isReady(), and both before mount(). The order is not a style
// question: installing the router on an app is what starts its first
// navigation, and isReady() resolves when that navigation finishes. Asking a
// router that no app has been given yet whether it is ready waits for
// something nobody has set in motion, and the promise never settles.
app.use(router);

// mount() clears the container, and the prerendered HTML of this page is what
// is in it. Waiting for the first navigation - which includes fetching the
// route's lazy chunk - means the replacement exists before the original is
// thrown away, instead of an empty <main> for one round trip.
void router.isReady().then(() => {
  app.mount("#app");
});
